module.exports = __webpack_public_path__ + "static/media/content-view-column.a0d2bef7.svg";